import { render } from "./ListSakitAllView.vue?vue&type=template&id=15b4d9a5"
import script from "./ListSakitAllView.vue?vue&type=script&lang=js"
export * from "./ListSakitAllView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__